import styled, { keyframes } from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextRS, TextMS } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const RegisterHeader = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RegisterHeaderText = styled(TextRS)`
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 24px;
  }
`;

export const RegisterWrapper = styled.div`
  width: 100%;
  height: 60%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const CheckboxWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-top: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 25px;
    padding-top: 50px;
  }
`;

export const CheckboxTerms = styled.div`
  border-top: 1px solid rgb(159, 159, 159, 0.2);
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-top: 15px;
  margin-bottom: 10px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 25px;
    gap: 25px;
  }
`;

export const CheckboxTermWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
`;

export const DetailTermBtn = styled(TextRS)`
  font-size: 13px;
  color: #9f9f9f;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 22px;
  }
`;

const bottomSheetMountAnimation = keyframes`
  from {
    height: 0px;
  }
  to {
    height: 200px;
  }
`;

export const DetailTerm = styled.div`
  height: 200px;
  background-color: #eaeaea;
  padding: 10px;
  overflow: scroll;
  animation: ${bottomSheetMountAnimation} 0.75s ease-out forwards;
  ::-webkit-scrollbar {
    display: none;
  }
  font-size: 13px;
  line-height: 1.2;
  @media ${({ theme }) => theme.device.tablet} {
    padding: 20px;
    font-size: 22px;
  }
`;

export const CheckboxLabel = styled.label`
  font-family: "Bold";
  font-size: 15px;
  display: flex;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 22px;
  }
`;

export const Checkbox = styled.input`
  width: 20px;
  height: 20px;
  margin: 0 15px 0 0;
  @media ${({ theme }) => theme.device.tablet} {
    width: 40px;
    height: 40px;
  }
`;

export const NextButton = styled.div`
  width: 90%;
  height: 50px;
  border-radius: 5px;
  background-color: ${({ color }) => (color ? "#f44b59" : "#eaeaea")};
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${({ theme }) => theme.device.tablet} {
    height: 60px;
  }
`;

export const NextButtonText = styled(TextMS)`
  font-size: 18px;
  color: ${({ color }) => (color ? "#FFF" : "#9F9F9F")};
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 28px;
  }
`;
